import React from "react"
import { UserAssessmentResult, UserCertification } from "../model/certification"
import { Assessment } from "../model/module"
import { Session } from "../model/session"
import { TableRow, TableCell, Collapse, Box, Table, TableHead, TableBody, IconButton, Typography, Tooltip } from "@mui/material"
import { Verified } from "@mui/icons-material"
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { UserCertAssessmentRow } from "./usercertassessment"
import { Course } from "../model/course"


export const UserCertCourseRow = (props: { userCert: UserCertification, courses: Course[], firstName: string, lastName: string, department: string}) => {
    const { userCert, courses, firstName, lastName, department } = props;
    const [open, setOpen] = React.useState(false);
    
    const allCourseAssessments = (courses: Course[]): Assessment[] | [] => {
        let result: Assessment[] = []
        for (let course of courses) {
            let assessments = findCourseAssessments(course)
            if (assessments.length > 0) {
                result.push(...assessments)
            }
        }
        return result
    }

    const findCourseAssessments = (course: Course): Assessment[] | [] => {
        let result: Assessment[] = []
        for (let session of course.sessions) {
            for (let module of session.contentModules) {
                if (module.type == "assessment") {
                    let assessment = module as Assessment
                    if (assessment.passThresholdPercentage > 0) {
                        result.push(assessment)
                    }
                }
            }
        }
        return result
    }

    const countPassedAssessments = (assessments: Assessment[], results: UserAssessmentResult[]): number => {
        let validIds = assessments.map(a => a.uuid)
        let passed = results.filter(result => result.passed && validIds.includes(result.assessmentId))
        return passed.length
    }

    const assessments = allCourseAssessments(courses)
    const passedAssessments = countPassedAssessments(assessments, userCert.assessments)

    return (
        <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' }}}>
                <TableCell width={50}>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon/>: <KeyboardArrowDownIcon/>}
                    </IconButton>
                </TableCell>
                <TableCell width={50}>
                    {
                        assessments.length > 0 ?
                            (
                                userCert.certified ? 
                                    <Tooltip title="This user has passed all the assessments within this program">
                                        <span style={{ cursor: 'help' }}>
                                            <Verified/>
                                        </span>
                                    </Tooltip>: 

                                    <Tooltip title="This user has not yet passed all the assessments within this program">
                                        <span style={{ cursor: 'help' }}>
                                            <RadioButtonUncheckedIcon/>
                                        </span>
                                    </Tooltip>
                            ):
                            (
                                <Tooltip title="There are no assessments in this program, therefore we cannot certify the user">
                                    <span style={{ cursor: 'help' }}>
                                        <HorizontalRuleIcon/>
                                    </span>
                                </Tooltip>
                            )
                    }
                </TableCell>
                <TableCell width={100}>
                    {passedAssessments} / {assessments.length}
                </TableCell>
                <TableCell>{userCert.userEmail}</TableCell>
                <TableCell>{firstName}</TableCell>
                <TableCell>{lastName}</TableCell>
                <TableCell>{department}</TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={{ padding: 0 }} colSpan={7}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box sx={{ margin: 1 }}>
                        <Table size="small" aria-label="assessmentInfo">
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell>Chapter</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                courses.map(course => {
                                    let foundAssessments = findCourseAssessments(course)
                                    if (foundAssessments.length > 0) {
                                        return(
                                            <UserCertAssessmentRow 
                                                key={userCert.userId} 
                                                userCert={userCert} 
                                                course={course} 
                                                assessments={foundAssessments} />
                                        )}
                                    }
                                )
                            }
                        </TableBody>
                        </Table>
                    </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}